import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12bf6fd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex" }
const _hoisted_2 = { class: "p-flex-column p-mr-3" }
const _hoisted_3 = { class: "box-stats" }
const _hoisted_4 = { class: "budget p-d-block" }
const _hoisted_5 = {
  key: 0,
  class: "bold"
}
const _hoisted_6 = {
  key: 1,
  class: "bold"
}
const _hoisted_7 = { class: "budget p-d-block" }
const _hoisted_8 = {
  key: 0,
  class: "bold"
}
const _hoisted_9 = {
  key: 1,
  class: "bold"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "box-stats" }
const _hoisted_12 = { class: "budget p-d-block" }
const _hoisted_13 = {
  key: 0,
  class: "bold"
}
const _hoisted_14 = {
  key: 1,
  class: "bold"
}
const _hoisted_15 = { class: "budget p-d-block" }
const _hoisted_16 = {
  key: 0,
  class: "bold"
}
const _hoisted_17 = {
  key: 1,
  class: "bold"
}
const _hoisted_18 = { class: "p-flex-column" }
const _hoisted_19 = { class: "box-stats" }
const _hoisted_20 = { class: "budget p-d-block" }
const _hoisted_21 = {
  key: 0,
  class: "bold"
}
const _hoisted_22 = {
  key: 1,
  class: "bold"
}
const _hoisted_23 = { class: "budget p-d-block" }
const _hoisted_24 = {
  key: 0,
  class: "bold"
}
const _hoisted_25 = {
  key: 1,
  class: "bold"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = {
  key: 0,
  class: "budget p-d-block"
}
const _hoisted_28 = { class: "bold" }
const _hoisted_29 = {
  key: 1,
  class: "budget p-d-block"
}
const _hoisted_30 = { class: "bold" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" Per Month "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode("IOS: "),
          (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPI)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.data?.forPay?.ios), 1))
            : _createCommentVNode("", true),
          (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPC)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " 0 "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", _hoisted_7, [
          _createTextVNode("Total: "),
          (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPC)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " 0 "))
            : _createCommentVNode("", true),
          (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPI)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.calculateCpiRate(_ctx.data?.forPay?.ios * _ctx.data?.cpi?.ios?.amount, _ctx.data?.appliedFee)) + " " + _toDisplayString(_ctx.data?.cpi?.ios?.currency), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", _hoisted_12, [
          _createTextVNode("Android: "),
          (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPC)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "0"))
            : _createCommentVNode("", true),
          (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPI)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.data?.forPay?.android), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", _hoisted_15, [
          _createTextVNode("Total: "),
          (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPC)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, " 0 "))
            : _createCommentVNode("", true),
          (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPI)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.calculateCpiRate(_ctx.data?.forPay?.android * _ctx.data?.cpi?.android?.amount, _ctx.data?.appliedFee)) + " " + _toDisplayString(_ctx.data?.cpi?.android?.currency), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("span", _hoisted_20, [
          _createTextVNode("Clicks: "),
          (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPC)
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.data?.forPay?.clicks), 1))
            : _createCommentVNode("", true),
          (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPI)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "0"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", _hoisted_23, [
          _createTextVNode("Total: "),
          (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPC)
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.calculateCpiRate(_ctx.data?.forPay?.clicks * _ctx.data?.cpc?.amount, _ctx.data?.appliedFee)) + " " + _toDisplayString(_ctx.data?.forPay?.clicks * _ctx.data?.cpc?.currency || ''), 1))
            : _createCommentVNode("", true),
          (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPI)
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, " 0 "))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_26,
      (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPI)
        ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
            _createTextVNode("Total: "),
            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.calculateCpiRate((_ctx.data?.forPay?.ios * _ctx.data?.cpi?.ios?.amount)
                  + (_ctx.data?.forPay?.android * _ctx.data?.cpi?.android?.amount), _ctx.data?.appliedFee)), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.data?.forPay?.currency), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.data?.paymentMethod === _ctx.CampaignPaymentMethod.CPC)
        ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
            _createTextVNode("Total: "),
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.calculateCpiRate(_ctx.data?.forPay?.clicks * _ctx.data?.cpc?.amount, _ctx.data?.appliedFee)), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.data?.budget?.currency), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_31
  ]))
}